import { CloseRounded } from "@mui/icons-material";
import {
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../App";
import { action, controller, Server } from "../../api/Server";
import StatusWidget from "./StatusWidget";
import { formatDate } from "../../hooks/Method";

const ViewDetails = ({ setShowForm, id }) => {
  const { t } = useTranslation();
  const { settings } = useContext(AppContext);
  const [value, setValue] = useState({});

  useEffect(() => {
    if (id) {
      Server(controller.QuoteSale + action.GetById).getById(id, (res) => {
        if (res.status === 200 && res.result && res.result.id) {
          var _result = res.result;
          setValue(_result);
        }
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      {settings && value.id ? (
        <div>
          <div className="d-flex j-between a-center pr-10">
            <h1 className="fs-18 ml-10 fw-5 gray-color tx-upp">
              {t("quoteSaleDetails")}
            </h1>

            <IconButton size="small" onClick={() => setShowForm(false)}>
              <CloseRounded />
            </IconButton>
          </div>
          <Divider />
          <Grid container>
            <Grid item xs={12}>
              <TableContainer className="mt-20">
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("itemName")}</TableCell>
                      <TableCell>{t("quantity")}</TableCell>
                      <TableCell>{t("price")}</TableCell>
                      <TableCell>{t("total")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {value.quoteItems.map((item, i) => (
                      <TableRow key={i}>
                        <TableCell>{item.product.name}</TableCell>
                        <TableCell>{item.qty}</TableCell>
                        <TableCell>
                          {settings.curSymbol +
                            " " +
                            item.price.toFixed(settings.decimal)}
                        </TableCell>
                        <TableCell>
                          {settings.curSymbol +
                            " " +
                            (item.qty * item.price).toFixed(settings.decimal)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Divider />
              <Divider />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              className="w-100pr"
              sx={{
                borderRight: { sm: "1px solid var(--grayLight-color)" },
              }}
            >
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    {value.customer && (
                      <TableRow>
                        <TableCell>{t("customer")}</TableCell>
                        <TableCell align="right">
                          {value.customer.fullName} | {value.customer.phone}
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell>{t("id")}</TableCell>
                      <TableCell align="right">{value.id}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("cashier")}</TableCell>
                      <TableCell align="right">
                        {value.user?.fullName}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("status")}</TableCell>
                      <TableCell align="right">
                        <StatusWidget status={value.status} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("quoteDate")}</TableCell>
                      <TableCell align="right">
                        {formatDate(value.quoteDate)}
                      </TableCell>
                    </TableRow>
                    {value.note && (
                      <TableRow>
                        <TableCell>{t("note")}:</TableCell>
                        <TableCell align="right">
                          <span style={{ whiteSpace: "pre-wrap" }}>
                            {value.note}
                          </span>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableHead>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} sm={6} className="w-100pr">
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("totalItem")}</TableCell>
                      <TableCell align="right">{value.totalQty}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("subtotal")}</TableCell>
                      <TableCell align="right">
                        {settings.curSymbol +
                          " " +
                          value.subtotal.toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>
                    {value.tax > 0 && (
                      <TableRow>
                        <TableCell>
                          {t("tax")}({value.taxPct}%)
                        </TableCell>
                        <TableCell align="right">
                          {settings.curSymbol +
                            " " +
                            value.tax.toFixed(settings.decimal)}
                        </TableCell>
                      </TableRow>
                    )}
                    {value.disAmt > 0 && (
                      <TableRow>
                        <TableCell>{t("discount")}</TableCell>
                        <TableCell align="right">
                          -{" "}
                          {settings.curSymbol +
                            " " +
                            value.disAmt.toFixed(settings.decimal)}
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell className="primary-color">
                        {t("toPay")}
                      </TableCell>
                      <TableCell align="right" className="primary-color">
                        {settings.curSymbol +
                          " " +
                          parseFloat(value.toPay).toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </div>
      ) : (
        "Loading..."
      )}
    </>
  );
};

export default ViewDetails;
